export function formatResult(result) {
    if (!result)
        return [];
    if (typeof result === 'string') {
        let list = [];
        try {
            list = formatResult(JSON.parse(result));
        }
        catch (err) {
            console.error(err);
        }
        return list;
    }
    if (Array.isArray(result))
        return result;
    if (Array.isArray(result?.list))
        return result.list;
    if (Array.isArray(result?.content))
        return result.content;
    return [];
}
